import { Component, OnInit } from '@angular/core';
import { MessageService } from 'src/app/services/message.service';
import { SubmenuService } from '../../submenu/submenu.service';
import { FormactionService } from 'src/app/services/formaction/formaction.service';

@Component({
  selector: 'app-formaction-list',
  templateUrl: './formaction-list.component.html',
  styleUrls: ['./formaction-list.component.less']
})
export class FormactionListComponent  implements OnInit {

  page:number = 1;
  pageSize:number = 25;
  queryString= "";
  listData:any[];

  constructor(public formactionService:FormactionService, public messageService:MessageService, public submenuService:SubmenuService)
  { 

  }

  ngOnInit(): void {
    
    this.loadData();
  }

  ngAfterViewChecked(){
    this.submenuService.showRecordList("/formaction");    
  }

  loadData(){
    this.messageService.showLoading();
    this.formactionService.loadPage(this.page, this.pageSize, this.queryString).subscribe(
      (data:any) => {
        this.listData = data;
        this.messageService.hideLoading();
    },
    
    err => {
      this.messageService.hideLoading();
      this.messageService.showMessage(err.message, "error");
      console.log(err);
    });
  }

}
